import type { StreamProvider } from '@vgtv/api-client';
import { ProviderAccessMap } from '@vgtv/svp-access/lib/access_mappings';
import cn from 'classnames';
import { ComponentChild, FunctionComponent } from 'preact';

import { PaywallLayoutLabel } from './PaywallLayoutLabel';

interface UpcomingProps {
  isCountdownActive?: boolean;
  isMobile: boolean;
  label?: string | ComponentChild;
  accessLevel?: ProviderAccessMap[StreamProvider];
}

export const Upcoming: FunctionComponent<UpcomingProps> = ({
  isCountdownActive,
  isMobile,
  label,
  accessLevel,
}) => {
  return (
    <div className="vgp-paywall-upcoming">
      <div
        className={cn('vgp-label-container', {
          'vgp-paywall-countdown': isCountdownActive,
        })}
      >
        <PaywallLayoutLabel
          hasAccess
          accessLevel={accessLevel}
          label={label}
          isMobile={isMobile}
        />
      </div>
    </div>
  );
};
